module.exports = __webpack_public_path__ + "img/img19.b71480f6.png";